import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getSize } from './utils';
 
@Pipe({ name: 'filesize' })
export class FileSizePipe implements PipeTransform {
    transform(v: string) {
        return getSize(v);
    }


    
}
